module.exports = __webpack_public_path__ + "img/gsjj.72cebd12.jpg";